import {Link} from '@aboutyou/router';
import styled from 'styled-components';

export const UnstyledLink = styled(Link)`
  &,
  &:hover,
  &:visited {
    text-decoration: none;
    color: inherit;
  }
`;
